import { Col } from "react-bootstrap";

const SkeletonCard = () => (
  <div className="skeleton-card">
    <div className="skeleton-card__image skeleton-pulse" />
    <div className="skeleton-card__body">
      <div className="skeleton-pulse skeleton-card__header" />
      <div className="skeleton-pulse skeleton-card__line" />
      <div className="skeleton-pulse skeleton-card__line skeleton-card__line--medium" />
      <div className="skeleton-pulse skeleton-card__line skeleton-card__line--short" />
    </div>
  </div>
);

export const Loader = ({ count = 3, lg = 4 }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <Col key={i} lg={lg} md={6} className="d-flex u-mb-medium">
        <SkeletonCard />
      </Col>
    ))}
  </>
);
